import { render, staticRenderFns } from "./NewRirekishoSinglePreview.vue?vue&type=template&id=0bd87b3c&"
import script from "./NewRirekishoSinglePreview.vue?vue&type=script&lang=js&"
export * from "./NewRirekishoSinglePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports